import React from "react";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
//import online from "./images/green-button-badge.jpg"
import $ from "jquery";

import NavbarComponent from "./NavbarComponent";
import HomePageComponent from "./HomePageComponent";
import ProfileQuoteComponent from "./ProfileQuote";
import SkillsComponent from "./SkillsComponent";
import TestimonialsComponent from "./TestimonialsComponent";
import ProjectsComponent from "./ProjectsComponent";
//import Chatbot from './ChatbotComponent';
import ContactComponent from "./ContactComponent";

class MainPage extends React.Component {
  componentDidMount() {
    $(".menu-icon").click(function() {
      $(this).toggleClass("opened");
    });
    $(document).ready(function() {
      $(".hamburger").click(function() {
        $(this).toggleClass("is-active");
      });
    });
    $(document).ready(function() {
      $(".nav-button").click(function() {
        $("body").toggleClass("nav-open");
      });
    });
  }

  render() {
    return (
      <div className="App">
        <NavbarComponent />
        <HomePageComponent />
        <ProfileQuoteComponent />
        <SkillsComponent />
        <TestimonialsComponent />
        <ProjectsComponent />
        <div className="footer-statement mb-0">
          <center className="m-auto">
            <div className="container ">
              <div className="p-1 mt-4">
                <h6 className="text-white">
                  Made with{" "}
                  <img
                    src="https://www.animatedimages.org/data/media/373/animated-heart-image-0458.gif"
                    border="0"
                    width="25"
                    alt="animated-heart-0458"
                  />{" "}
                  in India
                </h6>
                <p className="text-white">
                  Hardik Chugh &copy; 2023 - All rights reserved
                </p>
              </div>
            </div>
          </center>
        </div>
      </div>
    );
  }
}

export default MainPage;
